import React, { useContext, useState } from 'react';
import {makeStyles, useTheme, Button, CircularProgress} from '@material-ui/core';
import PageToolbar from '../components/pageToolbar';
import AutoTable from '../components/autoTable';
import globalContext from '../context/globalContext';
import BerthAdd from '../content/berthAdd';
import SideSlidePanel from '../components/sideSlidePanel';
import BerthEdit from '../content/berthEdit';

const useStyles = makeStyles(theme => ({
  container: {
    width: '100%',
    minHeight: '100%',
    flex: 1,
    display: 'flex',
    flexDirection: 'column'
  }
}))

const Berths = props => {

  const theme = useTheme();
  const classes = useStyles(theme);

  const context = useContext(globalContext);

  const [ showAdd, setShowAdd ] = useState(false);
  const [ edit, setEdit ] = useState(null);

  const headCells = [
    'id_berth',
    'berth_reference',
    'mooring_type',
    'loa_min',
    'loa_max',
    'loa_measurement',
    'map_reference'
  ]

  const handleRowClick = row => {
    setEdit(row);
  }

  return (
    <div className={classes.container}>

      <PageToolbar label="Berths">
        <div style={{flex: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingLeft: 20}}>
          <div>
            <Button variant="contained" color="default" style={{alignSelf: 'flex-start'}} onClick={() => setShowAdd(true)}>Add Berth</Button>
          </div>
        </div>
      </PageToolbar>


      <AutoTable loading={context.berths.status === 'LOADING'} rows={context.berths.data} orderBy="id_berth" handleRowClick={handleRowClick} headCells={headCells} />

      
      <SideSlidePanel title="Add Berth" side="left" show={showAdd} handleClose={() => {setShowAdd(false)}}><BerthAdd handleClose={() => {setShowAdd(false)}} /></SideSlidePanel>
      <SideSlidePanel title="Edit Berth" side="right" show={edit !== null} handleClose={() => {setEdit(null)}}><BerthEdit data={edit} handleClose={() => {setEdit(null)}} /></SideSlidePanel>
      

    </div>
  );
}

export default Berths;
